// extracted by mini-css-extract-plugin
export default {"awards":"awards_awards__IIU+2","awards_img":"awards_awards_img__mvVEF"};